"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _switch = _interopRequireDefault(require("../rc-components/switch"));
var _enum = require("../_util/enum");
var _ConfigContext = _interopRequireDefault(require("../config-provider/ConfigContext"));
var Switch = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Switch, _Component);
  var _super = (0, _createSuper2["default"])(Switch);
  function Switch() {
    var _this;
    (0, _classCallCheck2["default"])(this, Switch);
    _this = _super.apply(this, arguments);
    _this.saveSwitch = function (node) {
      _this.rcSwitch = node;
    };
    return _this;
  }
  (0, _createClass2["default"])(Switch, [{
    key: "focus",
    value: function focus() {
      if (this.rcSwitch) {
        this.rcSwitch.focus();
      }
    }
  }, {
    key: "blur",
    value: function blur() {
      if (this.rcSwitch) {
        this.rcSwitch.blur();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;
      var _this$props = this.props,
        customizePrefixCls = _this$props.prefixCls,
        size = _this$props.size,
        loading = _this$props.loading,
        _this$props$className = _this$props.className,
        className = _this$props$className === void 0 ? '' : _this$props$className;
      var getPrefixCls = this.context.getPrefixCls;
      var prefixCls = getPrefixCls('switch', customizePrefixCls);
      var classes = (0, _classnames["default"])(className, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-small"), size === _enum.Size.small), (0, _defineProperty2["default"])(_classNames, "".concat(prefixCls, "-loading"), loading), _classNames));
      return /*#__PURE__*/_react["default"].createElement(_switch["default"], (0, _extends2["default"])({}, (0, _omit["default"])(this.props, ['loading']), {
        prefixCls: prefixCls,
        className: classes,
        ref: this.saveSwitch
      }));
    }
  }], [{
    key: "contextType",
    get: function get() {
      return _ConfigContext["default"];
    }
  }]);
  return Switch;
}(_react.Component);
exports["default"] = Switch;
Switch.displayName = 'Switch';